import React from 'react';
import TemplatesP1 from './TemplatesP1';
import TemplatesP2 from './TemplatesP2';
import TemplatesP3 from './TemplatesP3';
import TemplatesP4 from './TemplatesP4';
import TemplatesP5 from './TemplatesP5';
import TemplatesP6 from './TemplatesP6';
import TemplatesP7 from './TemplatesP7';
import TemplatesP9 from './TemplatesP9';
import TemplatesP10 from './TemplatesP10';
import TemplatesP11 from './TemplatesP11';
import TemplatesP12 from './TemplatesP12';
import TemplatesP14 from './TemplatesP14';
import TemplatesP16 from './TemplatesP16';
import TemplatesP17 from './TemplatesP17';
import TemplatesP18 from './TemplatesP18';
import TemplatesP19 from './TemplatesP19';
import TemplatesP20 from './TemplatesP20';
import TemplatesP21 from './TemplatesP21';
import TemplatesP22 from './TemplatesP22';

const Templates = (props) => {
    if (parseInt(props.productId) === 1) {
        return <TemplatesP1 {...props} />;
    } else if (parseInt(props.productId) === 2) {
        return <TemplatesP2 {...props} />;
    } else if (parseInt(props.productId) === 3) {
        return <TemplatesP3 {...props} />;
    } else if (parseInt(props.productId) === 4) {
        return <TemplatesP4 {...props} />;
    } else if (parseInt(props.productId) === 5) {
        return <TemplatesP5 {...props} />;
    } else if (parseInt(props.productId) === 6) {
        return <TemplatesP6 {...props} />;
    } else if (parseInt(props.productId) === 7) {
        return <TemplatesP7 {...props} />;
    } else if (parseInt(props.productId) === 9) {
        return <TemplatesP9 {...props} />;
    } else if (parseInt(props.productId) === 10) {
        return <TemplatesP10 {...props} />;
    } else if (parseInt(props.productId) === 11) {
        return <TemplatesP11 {...props} />;
    } else if (parseInt(props.productId) === 12) {
        return <TemplatesP12 {...props} />;
    } else if (parseInt(props.productId) === 14) {
        return <TemplatesP14 {...props} />;
    } else if (parseInt(props.productId) === 16) {
        return <TemplatesP16 {...props} />;
    } else if (parseInt(props.productId) === 17) {
        return <TemplatesP17 {...props} />;
    } else if (parseInt(props.productId) === 18) {
        return <TemplatesP18 {...props} />;
    } else if (parseInt(props.productId) === 19) {
        return <TemplatesP19 {...props} />;
    } else if (parseInt(props.productId) === 20) {
        return <TemplatesP20 {...props} />;
    } else if (parseInt(props.productId) === 21) {
        return <TemplatesP21 {...props} />;
    } else if (parseInt(props.productId) === 22) {
        return <TemplatesP22 {...props} />;
    }
    return null;
}

export default Templates;
